import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Home, ArrowLeft } from 'lucide-react';
import { Layout } from '@/components/layout/Layout';
import { Button } from '@/components/ui/button';

const NotFound = () => {
  const { t } = useTranslation();

  return (
    <Layout>
      <section className="section-padding bg-background min-h-[60vh] flex items-center">
        <div className="container-narrow text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 className="font-heading text-7xl md:text-9xl font-bold text-bronze mb-4">
              404
            </h1>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground mb-4">
              {t('notFound.title')}
            </h2>
            <p className="font-body text-muted-foreground mb-8 max-w-md mx-auto">
              {t('notFound.description')}
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button variant="bronze" size="lg" asChild>
                <Link to="/" className="gap-2">
                  <Home className="w-4 h-4" />
                  {t('nav.home')}
                </Link>
              </Button>
              <Button variant="outline" size="lg" asChild>
                <Link to="/collections" className="gap-2">
                  <ArrowLeft className="w-4 h-4" />
                  {t('nav.collections')}
                </Link>
              </Button>
            </div>
          </motion.div>
        </div>
      </section>
    </Layout>
  );
};

export default NotFound;